import React from 'react';
import { SectionLabel } from './SectionLabel';
export function Application() {
  return <section id="application" className="py-40 px-6 md:px-12 lg:px-24 max-w-4xl mx-auto border-t border-ink/10" data-id="element-1" data-mp="3auctpar3ab2e">
      <SectionLabel number="04" title="The Application" data-id="element-2" data-mp="3om9m7fwo6mzb" />

      <div className="max-w-2xl" data-id="element-3" data-mp="3jv1bmgjlsvkk">
        <h2 className="text-5xl md:text-6xl mb-8" data-id="element-4" data-mp="3jtq6odef9hrv">Request Consideration</h2>
        <p className="font-sans text-lg font-light text-ink/80 leading-relaxed mb-6" data-id="element-5" data-mp="2druglo9ewch">
          The application is the first step. Qualified candidates are invited
          to a discovery call, where fit and scope are discussed. Pricing is
          presented during this conversation.
        </p>
        <p className="font-sans text-lg font-light text-ink/80 leading-relaxed mb-16" data-id="element-6" data-mp="6fd5s2l5b2kk">
          It takes a few minutes. Every application is read personally.
        </p>
        <a href="https://form.jotform.com/262156242446051" target="_blank" rel="noopener noreferrer" className="cta-link" data-id="element-7" data-mp="2d85r26ecisso">
          Begin the Application
          <span className="ml-2 font-serif text-lg leading-none" data-id="element-8" data-mp="e55ntolsyu9l">{'\u2192'}</span>
        </a>
      </div>
    </section>;
}